export default "__VITE_ASSET__n3KQ$HF5__"